/**
 * English words a Dutch lesson must not use (lesson builder spec §6.1, `dutch-only`): the function words and
 * the science words the generator was seen to write ("Lateral line" beside "Laterale lijn"). A small list in
 * our own code, no external word list (spec §14). Never a word that is also Dutch ("is", "in", "of", "hand",
 * "arm", "was", "door", "over", "been", "top", "made", …): a real Dutch word must never fail the check.
 */
/** English science words with their Dutch, so a translated hotspot title reads as the same point. */
export const ENGLISH_TO_DUTCH = new Map([
    ['line', 'lijn'],
    ['lines', 'lijnen'],
    ['lateral', 'lateraal'],
    ['fin', 'vin'],
    ['fins', 'vinnen'],
    ['dorsal', 'rug'],
    ['pectoral', 'borst'],
    ['pelvic', 'buik'],
    ['caudal', 'staart'],
    ['tail', 'staart'],
    ['head', 'kop'],
    ['jaw', 'kaak'],
    ['jaws', 'kaken'],
    ['tooth', 'tand'],
    ['teeth', 'tanden'],
    ['skull', 'schedel'],
    ['claw', 'klauw'],
    ['claws', 'klauwen'],
    ['scales', 'schubben'],
    ['skin', 'huid'],
    ['spine', 'ruggengraat'],
    ['bone', 'bot'],
    ['bones', 'botten'],
    ['eye', 'oog'],
    ['eyes', 'ogen'],
    ['mouth', 'bek'],
    ['neck', 'nek'],
    ['legs', 'poten'],
    ['foot', 'voet'],
    ['feet', 'voeten'],
    ['wing', 'vleugel'],
    ['wings', 'vleugels'],
    ['gill', 'kieuw'],
    ['gills', 'kieuwen'],
    ['crater', 'krater'],
    ['volcano', 'vulkaan'],
    ['smoke', 'rook'],
    ['steam', 'stoom'],
    ['mill', 'molen'],
    ['sail', 'zeil'],
    ['sails', 'zeilen'],
    ['tide', 'getij'],
    ['sea', 'zee'],
    ['river', 'rivier'],
    ['dike', 'dijk'],
    ['dyke', 'dijk'],
    ['pump', 'pomp'],
    ['side', 'zijkant'],
    ['back', 'rug'],
]);
/** Split on spaces: one list, easy to read and to extend. */
const FUNCTION_WORDS = [
    'the and with this that these those are you your for from into onto about which what when where',
    'who why how there their they them its were being has will would could should can cannot not but',
    'or if then than very only just some many much more each every other because while after before',
    'between through under above below near inside outside without within our my his she to on by up',
    'out off see find get make left right bottom view point high low',
]
    .join(' ')
    .split(' ');
export const ENGLISH_WORDS = new Set([
    ...FUNCTION_WORDS,
    ...ENGLISH_TO_DUTCH.keys(),
]);
//# sourceMappingURL=english-words.js.map